module.exports = __webpack_public_path__ + "static/media/safetyBonuses.59d5aa94.svg";